module.exports = __webpack_public_path__ + "img/KY.69021ebc.svg";